import type React from 'react';

interface ArticleBlockquoteProps {
  text: string | null | undefined;
}

export const ArticleBlockquote: React.FC<ArticleBlockquoteProps> = ({
  text,
}) => {
  if (!text) {
    return null;
  }
  return (
    <blockquote className='border-l-4 border-gray-200 pl-3 mb-4'>
      <p className='text-tiny text-gray-500 italic'>{text}</p>
    </blockquote>
  );
};
